import type { ReactNode } from 'react';

export const symbol_burst_mode: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M40-230v-500q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v500q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q40-217.25 40-230Zm160 0v-500q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v500q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Zm220 30q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h440q24 0 42 18t18 42v440q0 24-18 42t-42 18H420Zm0-60h440v-440H420v440Zm200-120-49-66q-5-6-12-6t-12 6l-49 65q-5 8-1 16t13 8h264q8.5 0 12.75-8t-.75-16l-70-93q-5-6-12-6t-12 6l-72 94ZM420-260v-440 440Z"
		/>
	</svg>
);
